import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-fast-forward",
  "use": "icon-fast-forward-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-fast-forward\" id=\"icon-fast-forward\"><polygon points=\"13 19 22 12 13 5 13 19\" /><polygon points=\"2 19 11 12 2 5 2 19\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol